module.exports = __webpack_public_path__ + "img/symbol_18_free.df5b78a1.png";